import React from 'react'
import { Flex } from 'antd'
import type { FlowStep, FlowBranding } from '@/data'
import { SavingsEstimatesBuilder } from './templates/SavingsEstimates'
import { FindingAssistanceBuilder } from './templates/FindingAssistance'
import { GettingStartedBuilder } from './templates/GettingStarted'
import { BrandingEditor } from './BrandingEditor'

interface FormBuilderProps {
  template: string
  state: FlowStep[]
  onChange: (state: FlowStep[]) => void
  onDeleteStep?: (stepId: number) => void
  branding?: FlowBranding
  onBrandingChange?: (branding: FlowBranding) => void
  brandingEnabled?: boolean
  onBrandingToggle?: (enabled: boolean) => void
}

const cobrandingTemplates = ['savings-estimates', 'getting-started']

export const FormBuilder: React.FC<FormBuilderProps> = ({
  template,
  state,
  onChange,
  onDeleteStep,
  branding,
  onBrandingChange,
  brandingEnabled,
  onBrandingToggle,
}) => {
  const showBranding =
    cobrandingTemplates.includes(template) &&
    branding &&
    onBrandingChange &&
    onBrandingToggle != null

  const templateBuilder = (() => {
    switch (template) {
      case 'finding-assistance':
        return (
          <FindingAssistanceBuilder
            steps={state}
            onChange={onChange}
            onDeleteStep={onDeleteStep}
          />
        )
      case 'getting-started':
        return (
          <GettingStartedBuilder
            steps={state}
            onChange={onChange}
            onDeleteStep={onDeleteStep}
          />
        )
      case 'savings-estimates':
      default:
        return (
          <SavingsEstimatesBuilder
            formSteps={state}
            onChange={onChange}
            onDeleteStep={onDeleteStep}
          />
        )
    }
  })()

  return (
    <Flex vertical gap="middle">
      {showBranding && (
        <BrandingEditor
          branding={branding}
          onChange={onBrandingChange}
          enabled={brandingEnabled ?? false}
          onToggle={onBrandingToggle}
        />
      )}
      {templateBuilder}
    </Flex>
  )
}
